import styled from "styled-components/macro";
import fixelLogo from "../../img/Fixel_Logo2019vector1.svg";
import {device} from "../../device";

export const StyledNavbar = styled.nav`
  border: 1px solid #dfe3e8;
  width: 100%;

  background: #f4f6f8;

  position: sticky;
  top: 0;
  z-index: 10;
`;

export const StyledSignIn = styled.div`
  margin-top: 1rem;
`;

export const FormContainer = styled.div`
   margin: 0 auto;
   width: calc(100% - 120px);
`;

export const StyledInput = styled.input`
    background: #F5F5F5 !important;
    border: 1px solid #DBDBDB !important;
    box-sizing: border-box !important;
    border-radius: 2.03125px !important;  
    padding: .6rem !important;
    width: 100% !important;
    margin-bottom: .8rem !important;
`;

export const StyledLabel = styled.label`
  color: #272B2F;  
  opacity: 0.5;
  margin-bottom: 1rem;
`;

export const StyledWrapperInput = styled.div`
    display: flex;
    gap: 1rem;
`

export const StyledForm = styled.form``;

export const StyledFormWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; 
  grid-template-rows: 400px;
  @media ${device.tablet}{
    grid-template-columns: 1fr;
  }
`;

export const StyledLeftForm = styled.div`
    background: #ffffff;
    padding: 1rem 1.6rem 2.2rem 1.6rem;
    display: flex;
    align-items: center;
    text-align: left;
    @media ${device.tablet}{
        padding: 2.2rem 0 2.2rem 0;
    }
`;

export const StyledRightForm = styled.div`
    padding: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(223.75deg, #F2BE41 0%, #FCEFCF 100%), #FFFFFF;
`;

export const StyledStar = styled.i`
    color: red;
    &:before {
        content: " ";
        white-space: pre;
    }
`;

export const StyledButton = styled.button`
    background: #6270C6;
    color: #ffffff;
    border-radius: 2px;
    padding: 8px 12px;
    border: none;
    cursor: pointer;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

const fxlLogo = styled.img`
    margin: 2rem 0;
`

fxlLogo.defaultProps = {
    src : fixelLogo
}

export const FixelLogo = fxlLogo;


export const StyledSubTitle = styled.h2`
    margin: 4rem 0 2rem 0;
    text-align: center;
`

export const StyledMidBoxes = styled.div`
    display: flex;
    width: 100%;
    justify-content:
    space-evenly;
    gap: 2rem;
    @media ${device.tablet}{
        flex-wrap: wrap;
    }
`

export const MidBox = styled.div`
    background: #ffffff;
    padding: 2rem;
    a {
      z-index: 1;
      cursor: pointer;
    }
`

export const MidBoxIcon = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    background: #6270C6;
    border-radius: 50%;
    color: #ffffff;
    width: 48px;
    height: 48px;
    margin: 1rem auto 0 auto;
`

export const MidBoxTitle = styled.h4`
    color: #272B2F;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    margin: 1.4rem 0;
`

export const StyledDescription = styled.p`
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    opacity: 0.6;
`